export enum DataHooks {
  WRAPPER = 'dialog-wrapper',
  TITLE = 'dialog-title',
  CONTENT = 'dialog-content',
  CONFIRMATION_BUTTON = 'dialog-confirmation-button',
  CONFIRMATION_BUTTON_LABEL = 'dialog-confirmation-button-label',
}
